// When using SSR, browser globals are not available. If you try to use them, Node.js will throw an error
// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const ssrSafeDocument = typeof document === 'undefined' ? undefined : document
// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const ssrSafeWindow = typeof window === 'undefined' ? undefined : window
// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const ssrSafeLocation = typeof location === 'undefined' ? {pathname: '', origin: '', search: ''} : location
